/*
 * @Description: 岗位管理
 * @Author: wangwangwang
 * @Date: 2020-06-30 14:18:14
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-14 15:07:16
 */
import request from '@/utils/request'
export const Download = "/base/system/base/stations/export";

// 获取岗位数据
export function queryPage(data) {
  return request({
    url: '/base/system/base/stations/query_page',
    method: 'post',
    data
  })
}

// 获取岗位数据
export function queryJobPageByLimit(data) {
  return request({
    url: '/base/system/base/stations/query_page',
    // url: '/base/system/base/stations/query_page_by_limit',
    method: 'post',
    data
  })
}

export function saveOrUpdate(data) {
  return request({
    url: '/base/system/base/stations/save_or_update',
    method: 'post',
    data
  })
}
export function updateOrDelete(data) {
  return request({
    url: '/base/system/base/stations/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function updateSortnum(data) {
  return request({
    url: '/base/system/base/stations/update_sort_num',
    method: 'post',
    data
  })
}
export function ossaveOrUpdate(data) {
  return request({
    url: '/base/system/base/organization/stations/save_or_update',
    method: 'post',
    data
  })
}
/*岗位与职级的对应关系
 * 职级rankId
 *岗位stationsId*/
export function rssaveOrUpdate(data) {
  return request({
    url: '/base/system/base/rank/stations/save_or_update',
    method: 'post',
    data
  })
}
/*职务与职级的对应关系
 * 职级rankId
 * 职务postId
 */
export function rpsaveOrUpdate(data) {
  return request({
    url: '/base/system/base/rank/post/save_or_update',
    method: 'post',
    data
  })
}
/*岗位与职级的对应关系
 * 职级rankId
 *岗位stationsId*/
export function getrplist(data) {
  return request({
    url: '/base/system/base/rank/post/get_list',
    method: 'post',
    data
  })
}